import Responsive from "components/common/Responsive";
import WriteArea from "post/write/WriteArea";

export const WritePage = () => {
  return (
    <div className="WritePage">
      <Responsive>
        <WriteArea />
      </Responsive>
    </div>
  );
};